{
  "admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.body": [
    {
      "type": 0,
      "value": "We've brought the most relevant requests to the top."
    }
  ],
  "admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.button-done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.heading": [
    {
      "type": 0,
      "value": "Review requests quickly"
    }
  ],
  "adminhub.user.requests.count.message.spotlight.content.body": [
    {
      "type": 0,
      "value": "See how many times a user has tried to access their requested app"
    }
  ],
  "adminhub.user.requests.count.message.spotlight.content.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "adminhub.user.requests.count.message.spotlight.content.headline": [
    {
      "type": 0,
      "value": "View access attempts"
    }
  ],
  "growth-groot.pending-request-access-summary.message-template.in-app-notification.body": [
    {
      "type": 0,
      "value": "Approve or deny your users' requests for app access."
    }
  ],
  "growth-groot.pending-request-access-summary.message-template.in-app-notification.heading": [
    {
      "type": 1,
      "value": "totalRequests"
    },
    {
      "type": 0,
      "value": " access requests are waiting for review"
    }
  ],
  "user.access.settings.access.message.spotlight.content.body": [
    {
      "type": 0,
      "value": "Create a message that users in your organization will see when they want to request access to an app."
    }
  ],
  "user.access.settings.access.message.spotlight.content.got.it": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "user.access.settings.access.message.spotlight.content.headline": [
    {
      "type": 0,
      "value": "Create an access message"
    }
  ]
}